module.exports = __webpack_public_path__ + "site/img/21.e6d700e7.jpg";